// 문의하기
export const INQUIRY_CREATE = "/v2/thirdparty/inquiry/create";
// 지역검색
export const INQUIRY_REGION = "/v2/thirdparty/inquiry/region";
